<div class="input-group global-search">
  <div class="input-group-prepend">
    <div class="input-group-text">
      <i class="fas fa-search grey4 cursor-default"></i>
    </div>
  </div>
  <input type="search" #typeaheadDirective="bs-typeahead"
    [(ngModel)]="asyncSearch"
    [typeahead]="dataSource"
    [typeaheadAsync]="true"
    [optionsListTemplate]="customListTemplate"
    [typeaheadOptionField]="labelField"
    typeaheadOptionsLimit="1000"
    (typeaheadLoading)="onTypeaheadLoading($event)"
    (typeaheadNoResults)="onTypeaheadNoResults($event)"
    (typeaheadOnSelect)="onSelect($event)"
    (keydown.enter)="$event.preventDefault()"
    (focus)="onFocus($event)"
    (input)="onInput($event, typeaheadDirective)"
    [isAnimated]="true"
    container="body"
    placeholder="Search"
    class="form-control form-control-sm border-right-0"
    autocomplete="off">
  </div>

  <ng-template #customListTemplate let-matches="matches" let-query="query" let-typeaheadTemplateMethods>
    <div class="global-search-result list-group" (click)="$event.stopPropagation()">
      @if((isInternal || isClient) && asyncSearch){
      <div class="d-flex global-search-header">
        <div class=" d-flex align-items-center justify-content-start pl-0 move-up">
          <span class="nav-font14 py-2 px-2 grey4 ml-1">Filters</span>
        </div>
        <div class="col align-items-center justify-content-end no-padding pl-0 pr-1">
          <button
            (click)="setActiveFilter('projects')"
            class="grey4 ml-1 nav-font14"
            style="width: 91px;"
            [ngClass]="activeFilter=='projects'?'activeFilter':''"
          >
            <i class="mr-1 fa-light fa-suitcase"></i>
            Projects
          </button>
          
            <button
              (click)="setActiveFilter('team')"
              class="grey4 ml-1 nav-font14"
              [ngClass]="activeFilter=='team'?'activeFilter':''"
              style="width: 91px;"
            >
              <i class="mr-1 fa-md fa-team fak grey4 icon"></i>
              Team
            </button>
          

            @if(isInternal){
              <button
                (click)="setActiveFilter('clients')"
                class="grey4 ml-1 nav-font14"
                style="width: 91px;"
                [ngClass]="activeFilter=='clients'?'activeFilter':''"
              >
                <i class="mr-1 fa-clients fa-md fak grey4 icon"></i>
                Clients
              </button>
              <button
                (click)="setActiveFilter('vendors')"
                class="grey4 ml-1 nav-font14"
                style="width: 92px;"
                [ngClass]="activeFilter=='vendors'?'activeFilter':''"
              >
                <i class="mr-1 fa-md fa-vendors fak grey4 icon"></i>
                Vendors
              </button>
            }

        </div>
      </div>
    }
      <div class="overflow-y scrollbar" style="max-height: 500px;">
        @if(!asyncSearch){
          @if(recentSearches.length > 0){
            <div class="row ml-1 my-2">
              <div class="col-12">
                <span class="d-block text-nowrap nav-font14 grey3 ">Recent Activity</span>
              </div>
            </div>
          }
          @else {
            <div class="row ml-1 my-2">
              <div class="col-12">
                <span class="d-block text-nowrap nav-font14 grey3">Your recent activities will appear here.</span>
              </div>
            </div>
          }
          @for(item of recentSearches; track item){
            <a
              class="list-group-item px-3 py-2 list-group-item-action text-secondary border-0 border-top recent-searches"
              (click)="recentSearchSelect(item,$event)"
              (mousedown)="pressedItem=item"
              (mouseup)="pressedItem=null"
              (mouseleave)="pressedItem=null; hoveredItem = null"
              (mouseenter)="hoveredItem = item"
              [class.active]="hoveredItem === item"
              [ngClass]="pressedItem === item ? 'pressed':''"
            >
              <div class="row">
                <div class="col-8">
                  <span class="d-block nav-font14 nav-accent-blue mr-3 name wrap" [innerHTML]="item.label | highlight: asyncSearch"></span>
                  <span class="d-block text-nowrap font-weight-normal nav-font12 grey4 type" [innerHTML]="item.subLabel | highlight: asyncSearch"></span>
                </div>
                <div class="col-4 text-right align-content-center">
                  <span class="badge badge-pill font-weight-normal nav-font14">
                    @if(item.type == 'project' || item.type == 'summary'){
                      <i class="mr-1 fa-light fa-suitcase"></i>
                    }
                    @if(item.type == 'user'){
                      <i class="mr-1 fa-md fa-team fak grey4 icon"></i>
                    }
                    @if(item.type == 'client' || item.type == 'client_user'){
                      <i class="mr-1 fa-clients fa-md fak grey4 icon"></i>
                    }
                    @if(item.type == 'vendor' || item.type == 'vendor_user'){
                      <i class="mr-1 fa-md fa-vendors fak grey4 icon"></i>
                    }
                    {{getSearchText(item.type)}}
                  </span>
                </div>
              </div>
            </a>
          }
        }
        @if(asyncSearch){
          <div class="row ml-1 my-2 filter">
            <div class="col-12">
              @if(activeFilter == 'projects'){
                <span class="text-nowrap nav-font14 grey4">Projects</span>
              }
              @else if(activeFilter == 'team'){
                <span class="text-nowrap nav-font14 grey4">Team</span>
              }
              @else if(activeFilter == 'clients'){
                <span class="text-nowrap nav-font14 grey4">Clients</span>
              }
              @else if(activeFilter == 'vendors'){
                <span class="text-nowrap nav-font14 grey4">Vendors</span>
              }
              @else {
                <span class="text-nowrap nav-font14 grey4">All</span>
              }
              <span class="badge badge-pill badge-light m-1 font-weight-normal text-nowrap nav-font14 grey4 ml-3">{{resultsCount==-1?'':resultsCount}}</span>
            </div>
          </div>
          @for (match of matches; track match) {
            <a href="#"
              class="list-group-item py-2 list-group-item-action text-secondary border-0 border-top"
              (mouseenter)="typeaheadTemplateMethods.selectActive(match)"
              (mouseleave)="typeaheadTemplateMethods.selectActive(null)"
              (mousedown)="pressedItem=match.item"
              (mouseup)="pressedItem=null"
              (mouseleave)="pressedItem=null"
              (click)="typeaheadTemplateMethods.selectMatch(match, $event)"
              [class.active]="typeaheadTemplateMethods.isActive(match)"
              [ngClass]="{'archived': match.item.isArchived,
                          'hidden': !showItem(match.item.type),
                          'pressed': pressedItem === match.item
                        }"
              >
              <div class="row">
                <div class="col-8">
                  <span class="d-block nav-font14 nav-accent-blue mr-3 name wrap" [innerHTML]="match.item[labelField] | highlight: asyncSearch"></span>
                  <span class="d-block text-nowrap font-weight-normal nav-font12 grey4 type" [innerHTML]="match.item.subLabel | highlight: asyncSearch"></span>
                </div>
                <div class="col-4 text-right align-content-center">
                  <span class="badge badge-pill font-weight-normal nav-font14">
                    @if(match.item.type == 'project' || match.item.type == 'summary'){
                      <i class="mr-1 fa-light fa-suitcase"></i>
                    }
                    @if(match.item.type == 'user'){
                      <i class="mr-1 fa-md fa-team fak grey4 icon"></i>
                    }
                    @if(match.item.type == 'client' || match.item.type == 'client_user'){
                      <i class="mr-1 fa-clients fa-md fak grey4 icon"></i>
                    }
                    @if(match.item.type == 'vendor' || match.item.type == 'vendor_user'){
                      <i class="mr-1 fa-md fa-vendors fak grey4 icon"></i>
                    }
                    {{getSearchText(match.item.type)}}
                  </span>
                </div>
              </div>
            </a>
          }
        }
      </div>
    </div>
  </ng-template>
